import React from 'react'
import { Card } from 'react-bootstrap'

export function FundraiserComplete() {
  return (
    <Card>
      <Card.Body>
        <Card.Title>Fundraiser Closed</Card.Title>
        <Card.Text>
          This fundraiser has concluded. Thank you for your support.
        </Card.Text>
      </Card.Body>
    </Card>
  )
}

export default FundraiserComplete
